import React, { FC } from 'react'
import alwaysInsuredDesktop from './assets/always_insured_desktop.svg'
import alwaysInsuredMobile from './assets/always_insured_mobile.svg'
import freeReturnsDesktop from './assets/free_returns_desktop.svg'
import freeReturnsMobile from './assets/free_returns_mobile.svg'
import lockDesktop from './assets/lock_desktop.svg'
import lockMobile from './assets/lock_mobile.svg'
import { Flex, Box, Text, breakpoints } from '@components/gassan-ui'
import styled from 'styled-components'
import { useLocalization } from '@components/Localization'

const Icon = styled.div`
  color: ${p => p.theme.colors.tabaccoBrown};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 10rem;
  text-align: center;
  margin-bottom: 1rem;

  @media screen and (min-width: ${breakpoints.small}) {
    margin-bottom: 1.5rem;
  }

  img {
    width: 2rem;
    height: auto;
  }
  @media screen and (min-width: ${breakpoints.large}) {
    flex-direction: row;
    align-items: center;
    max-width: initial;
    margin-bottom: 0.5rem;

    img {
      width: 2.5rem;
      margin-right: 1.25rem;
    }
  }
`

const iconKeys: ['lock', 'free-returns', 'always-insured'] = [
  'lock',
  'free-returns',
  'always-insured'
]

const icons = {
  lock: [lockMobile, lockDesktop],
  'free-returns': [freeReturnsMobile, freeReturnsDesktop],
  'always-insured': [alwaysInsuredMobile, alwaysInsuredDesktop]
}

const USPs: FC = () => {
  const { messages } = useLocalization()
  return (
    <>
      <Flex
        flexDirection="column"
        alignItems={{ _: 'center', large: 'flex-start' }}
        my={{ _: '2rem', large: '3rem' }}
        ml={{ _: 0, large: '-0.25rem' }}
      >
        {iconKeys.map((icon, index) => (
          <Icon key={index}>
            <Box display={['block', 'none']}>
              <img src={icons[icon][0]} alt={icon} />
            </Box>
            <Box display={['none', 'block']}>
              <img src={icons[icon][1]} alt={icon} />
            </Box>
            <Text variant="small" color="tabaccoBrown" mb="0">
              {messages.global[icon]}
            </Text>
          </Icon>
        ))}
      </Flex>
    </>
  )
}

export default USPs
